import envs from '../../env'

export default {
  install(Vue) {
    Vue.prototype.$API_URL = envs.API_URL
    Vue.config.productionTip = false
  }
}
